import React, { memo } from "react";
import { ShimmerContainer, ShimmerContent, ShimmerBlock, ShimmerFooter } from "./Shimmer.styles";

const StealStoreShimmer = () => {
    return (
        <ShimmerContainer>
            <ShimmerContent>
                <ShimmerBlock height={50} marginBottom={12} />
                <ShimmerBlock height={190} marginBottom={28} />
                <ShimmerBlock height={80} marginBottom={28} />
                <ShimmerBlock height={190} marginBottom={28} />
                <ShimmerFooter height={60} marginBottom={16} />
            </ShimmerContent>
        </ShimmerContainer>
    );
};

export default memo(StealStoreShimmer);
